//boardirector local
export const environment = {
    production: false,
    apiUrl: "https://quest-backend.boardirector.co.il",
    envUrl: "https://quest-gcp.boardirector.co.il",
    redirectUri: "",
    boardirectorUrl: "",
    directorsViewUrl: "",
    client: 'directq',
    lang: 'he',
    title: "DirectQ",
    auth: "jwt",
    loginMethod: 'id&otp' as const, // Selected login method //ad or id&otp
    adminLoginMethod: 'ad' as const, // Selected login method //ad or id&otp
    IDPAppUrl: "",
    IDPAppUrlToLogin: "",
    formLastTimeMinutesInterval: 20,
    ExpirationMinutes: 20,
    azureApps: {
        tenatId: "",
        clientId: "",
        apiScope: ""
    },
    apiExposureEnabled: false,
    isDev: true,
    featurs: {
        approvalRequired: "ON", // ON / OFF
        expense: "ON",
        amountExpense: 3000
    }

}
